export const bo = '/bo/';
export const boBankPayments = '/bo/bank-payments/';
export const boPaymentOrders = '/bo/bank-payment-orders/';
export const boCommentsSnap = '/bo/orders/comments-snap/';
export const boOrders = '/bo/orders/';
export const boOrdersAttachment = '/bo/orders-dj/attachment/:attachmentId/';
export const boOrdersChart = '/bo/orders/chart/';
export const boOrderCreate = '/bo/orders/create/';
export const boOrdersDetail = '/bo/orders/:orderId/';
export const boOrdersEdit = '/bo/orders/:orderId/edit/';
export const boOrdersHistory = '/bo/orders/:orderId/history/';
export const boOrdersProducts = '/bo/orders/products/';
export const boOrdersReportTesting = '/bo/orders/report/:orderId/testing/:orderItemId/';
export const boOrdersReportAmbassador = '/bo/orders/report/:orderId/ambassador/:orderItemId/:yearMonth/';
export const boOrdersReport = '/bo/orders/report/:orderId/';
export const boOrdersSigned = '/bo/orders/signed/';
